const browserLocation =
  typeof window !== "undefined" && typeof window.location !== "undefined"
    ? window.location
    : null;

const remoteWebOrigin =
  browserLocation &&
  !["localhost", "127.0.0.1", "192.168.1.45"].includes(
    browserLocation.hostname,
  )
    ? browserLocation.hostname.endsWith(".ts.net")
      ? browserLocation.origin
      : `${browserLocation.origin}/tiktok`
    : null;

export const VIDEO_SERVER_BASE_URL =
  (browserLocation?.hostname === "127.0.0.1" && browserLocation.port === "19007"
    ? "http://127.0.0.1:3053"
    : remoteWebOrigin) ??
  (browserLocation?.hostname === "192.168.1.45"
    ? "http://192.168.1.45:3050"
    : "https://seaking.vip/tiktok");
